import React from 'react';
import UsuarioFormPageContrainer from './UsuarioFormPageContainer'

export class UsuarioFormPage extends React.Component{
    render(){
        return <UsuarioFormPageContrainer {...this.props}/>
    }
}
